import { useQuery } from '@tanstack/react-query';
import type { FeatureCollection } from 'geojson';
import { geoJsonBounds } from '../domain/paebm';

/** URL servida estaticamente a partir de `public/`. */
const MANCHA_URL = '/geo/mancha-pae-barragem-b.geojson';

export interface ManchaData {
  mancha: FeatureCollection | null;
  bounds: [[number, number], [number, number]] | null;
  isLoading: boolean;
  error: Error | null;
}

/**
 * Carrega a mancha de inundação PAE (oficial, IDE-Sisema) embutida em `public/`.
 * Estática — `staleTime: Infinity`, sem refetch.
 * Expõe `isLoading`/`error` para o componente dar feedback caso o GeoJSON falhe
 * (camada não-crítica: o mapa segue funcional sem a mancha, mas o usuário é avisado).
 */
export function useMancha(): ManchaData {
  const { data, isLoading, error } = useQuery({
    queryKey: ['mancha-pae'],
    queryFn: async (): Promise<FeatureCollection> => {
      const res = await fetch(MANCHA_URL);
      if (!res.ok) throw new Error(`Falha ao carregar mancha (HTTP ${res.status})`);
      return res.json() as Promise<FeatureCollection>;
    },
    staleTime: Infinity,
    retry: 1,
  });

  return {
    mancha: data ?? null,
    bounds: data ? geoJsonBounds(data) : null,
    isLoading,
    error: (error as Error) ?? null,
  };
}
